/*!
 * @license
 * Copyright Squiz Australia Pty Ltd. All Rights Reserved.
 */

import { DeviceType } from '@squiz/dxp-console-support';
import { NavigationSection } from '@squiz/sds';
import { NAV_SECTION_DATA_IDS } from './DataIds.constants';
import { DXP_MENU_CORE_SCREENS, DXP_MENU_PLATFORM_RESOURCES, DXP_MENU_USER_ACCOUNT } from './NavItems.constants';

/**
 * The main navigation menu section for all core items that make up DXP Console.
 */
export const DXP_MENU_CORE_SECTION: NavigationSection = {
  items: DXP_MENU_CORE_SCREENS,
  key: `menu-section-dxp-core`,
  label: `DXP Core`,
  showLabel: false,
};

/**
 * The main navigation menu section for platform resources.
 */
export const DXP_MENU_RESOURCES_SECTION: NavigationSection = {
  dataId: NAV_SECTION_DATA_IDS.resources,
  devices: [DeviceType.mobile],
  items: DXP_MENU_PLATFORM_RESOURCES,
  key: `menu-section-help`,
  label: `Resources`,
  showLabel: true,
};

/**
 * The main navigation menu section for user account options.
 */
export const DXP_MENU_USER_ACCOUNT_SECTION: NavigationSection = {
  dataId: NAV_SECTION_DATA_IDS.account,
  devices: [DeviceType.mobile],
  items: DXP_MENU_USER_ACCOUNT,
  key: `menu-section-account`,
  label: `Account`,
  showLabel: true,
};
